import { HttpClient } from '@wix/http-client';

/**
 * Shared browser Wix http client for same-origin `/api/*` calls. `@wix/http-client`
 * (via `@wix/headers`) attaches the standard Wix request headers — `x-xsrf-token`,
 * `x-wix-brand`, `consent-policy`, … — on its own, so call sites don't hand-roll any
 * of that. It throws on a non-2xx status by default, which the callers translate into
 * their retry/error UI.
 */
const client = new HttpClient();

export async function wixHttpPost<T>(url: string, body: unknown): Promise<T> {
  const { data } = await client.post<T>(url, body);
  return data;
}
